import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/deleteSupportMER/';

const deleteSoporteMER = async (soporteId, userLogin) => {
  try {
    const response = await axios.delete(
      `${baseUrl}${endpoint}${soporteId}`,
      { data: { usuario: userLogin } }
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: 500,
      message: 'Error al eliminar'
    };
  }
};


export { deleteSoporteMER };
